document.addEventListener('DOMContentLoaded', () => {
  const menuButton = document.querySelector('.menu-toggle');
  const navigation = document.querySelector('.site-nav');

  const closeMenu = () => {
    navigation?.classList.remove('open');
    document.body.classList.remove('menu-open');
    menuButton?.setAttribute('aria-expanded', 'false');
    menuButton?.setAttribute('aria-label', 'Open menu');
  };

  if (menuButton && navigation) {
    menuButton.addEventListener('click', () => {
      const isOpen = navigation.classList.toggle('open');
      document.body.classList.toggle('menu-open', isOpen);
      menuButton.setAttribute('aria-expanded', String(isOpen));
      menuButton.setAttribute('aria-label', isOpen ? 'Close menu' : 'Open menu');
    });
    navigation.querySelectorAll('a').forEach((link) => link.addEventListener('click', closeMenu));
    document.addEventListener('keydown', (event) => { if (event.key === 'Escape') closeMenu(); });
  }

  document.querySelectorAll('[data-home-target]').forEach((link) => {
    link.addEventListener('click', (event) => {
      const targetId = link.dataset.homeTarget;
      const target = targetId ? document.getElementById(targetId) : null;
      if (!target) return;

      event.preventDefault();
      closeMenu();
      target.scrollIntoView({
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        block: 'start'
      });
      window.history.replaceState(null, '', `#${targetId}`);
    });
  });

  document.querySelectorAll('[data-product-carousel]').forEach((carousel) => {
    const slides = Array.from(carousel.querySelectorAll('[data-carousel-slide]'));
    const count = carousel.querySelector('[data-carousel-count]');
    let active = 0;
    let startX = null;
    const show = (next) => {
      active = (next + slides.length) % slides.length;
      slides.forEach((slide, index) => {
        slide.classList.toggle('is-active', index === active);
        slide.setAttribute('aria-hidden', String(index !== active));
      });
      if (count) count.textContent = `${String(active + 1).padStart(2, '0')} / ${String(slides.length).padStart(2, '0')}`;
    };
    carousel.querySelector('[data-carousel-prev]')?.addEventListener('click', () => show(active - 1));
    carousel.querySelector('[data-carousel-next]')?.addEventListener('click', () => show(active + 1));
    carousel.addEventListener('touchstart', (event) => { startX = event.touches[0].clientX; }, { passive: true });
    carousel.addEventListener('touchend', (event) => {
      if (startX === null) return;
      const distance = event.changedTouches[0].clientX - startX;
      if (Math.abs(distance) > 45) show(active + (distance < 0 ? 1 : -1));
      startX = null;
    }, { passive: true });
  });
});
